<div
  class="dropdown-menu-container"
  [class.inverted]="type === 'inverted'"
  (click)="$event.stopPropagation()"
  (keyup.enter)="$event.stopPropagation()"
>
  <button class="button button-quaternary" (click)="onClick($event)">
    {{ buttonText }}
    <div class="arrow-down"></div>
  </button>

  <ng-container *ngIf="isOpen">
    <div class="menu-container arrow-box" tabindex="-1">
      <ng-container *ngFor="let section of sections">
        <div class="menu-section" [class.root]="!section.text">
          <div class="menu-section-header" *ngIf="section.text">{{ section.text }}</div>
          <div class="menu-section-items">
            <ng-container *ngFor="let item of section.items">
              <div
                class="item"
                tabindex="0"
                (click)="doAction($event, item.action)"
                (keyup.enter)="doAction($event, item.action)"
              >
                {{ item.text }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
